import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { defineMessages, useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';
// import { Portal } from 'react-portal';
import moment from 'moment';
import qs from 'query-string';
import {
  Container,
  Row,
  Col,
  StepperContainer,
  StepperHeader,
  StepperHeaderElement,
} from 'design-react-kit';

import { BodyClass, Helmet } from '@plone/volto/helpers';

import { RemoveBodyClass } from 'design-comuni-plone-theme/components/ItaliaTheme';

import { prenotazioneSteps } from '@redturtle/volto-io-prenoto/helpers';
import {
  getPrenotazione,
  resetPrenotazione,
} from '@redturtle/volto-io-prenoto/actions/booking';
import {
  PrenotazioneLuogo,
  PrenotazioneDataEOra,
  PrenotazioneDettagli,
  PrenotazioneRichiedente,
  PrenotazioneRiepilogo,
  PrenotazioneFailed,
  PrenotazioneConferma,
} from '@redturtle/volto-io-prenoto/components/View/PrenotazioneView';
/* STYLE */
import '@redturtle/volto-io-prenoto/components/View/PrenotazioneView/PrenotazioneView.scss';
import '@redturtle/volto-io-prenoto/components/View/PrenotazioneView/PrenotazioneViewPrint.scss';

const messages = defineMessages({
  prenotazione_title: {
    id: 'booking_prenotazione_title',
    defaultMessage: 'Prenotazione appuntamento',
  },
  prenotazioni_steps: {
    id: 'prenotazioni_steps',
    defaultMessage:
      'Ci sono {tot_steps} steps da completare. Sei allo step {actual_step} - {step_label}',
  },
  back: {
    id: 'booking_back',
    defaultMessage: 'Indietro',
  },
});

const PrenotazioneView = (content) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const location = useLocation();
  const params = qs.parse(location.search);

  moment.locale(intl.locale);

  const [activeStep, setActiveStep] = useState(0);
  const { STEPS } = prenotazioneSteps();

  const prenotazioneObjDefault = {
    booking_office: '',
    booking_folder: null,
    booking_month: '',
    booking_date: null,
    booking_type: '',
    booking_schema: {},
    currentPageDates: 1,
    avilable_booking_folders: [],
  };
  const [prenotazioneObj, setPrenotazioneObj] = useState(
    prenotazioneObjDefault,
  );

  const checkConfirmStep = (index, id, icon = false) => {
    if (index <= activeStep - 1 && activeStep >= 1) {
      return !icon ? 'confirmed' : 'it-check';
    } else if (!icon && STEPS[activeStep].id === id) {
      return 'active';
    } else return '';
  };

  // Prenotazione ADD
  const prenotazione = useSelector((state) => state.prenotazione);

  // Variabile a true quando si arriva da un link generato via mail dopo la conferma
  const [bookingExist, setBookingExist] = useState(false);

  // Bottone torna agli slot dopo un errore di selezione medesimo giorno prenotato
  const [backToSlots, setBackToSlots] = useState(false);

  const scrollToTop = () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  };

  /* Check booking_id param from url */
  useEffect(() => {
    if (params.booking_id) {
      dispatch(getPrenotazione(params.booking_id));
      setBookingExist(true);
    }

    // Reset api state prenotazione
    return () => {
      dispatch(resetPrenotazione());
    };
  }, [params.booking_id]);

  /*Check add prenotazione*/
  useEffect(() => {
    if (prenotazione.result || prenotazione.error) {
      scrollToTop();
      // Se prenotazioneObj viene azzerata si perdono la CustomerSatisfaction e l'Ufficio
      // setActiveStep(0);
      // setPrenotazioneObj(prenotazioneObjDefault);
      // //Reset api state prenotazione
      // return () => {
      //   dispatch(resetPrenotazione());
      // };
    }
  }, [prenotazione]);

  return (
    <>
      <BodyClass className="public-ui" />
      <RemoveBodyClass className="cms-ui" />
      <Container className="px-4 mt-4 prenotazione-view">
        <Helmet title={intl.formatMessage(messages.prenotazione_title)} />
        {(!prenotazione.result && !prenotazione.error) ||
        (prenotazione.error && backToSlots) ? (
          <>
            <Col xs="12" lg="10">
              {/* PRENOTAZIONE TITLE */}
              <div className="heading py-3 pb-lg-4">
                <h1 className="heading-title">
                  {intl.formatMessage(messages.prenotazione_title)}
                </h1>
              </div>
            </Col>
            <StepperContainer className="mb-4">
              {/* STEPS */}
              <StepperHeader>
                {STEPS.map((step, index) => (
                  <StepperHeaderElement
                    key={step.id}
                    variant={checkConfirmStep(index, step.id)}
                    icon={checkConfirmStep(index, step.id, true)}
                    aria-hidden={true}
                  >
                    {step.label}
                  </StepperHeaderElement>
                ))}
                <StepperHeaderElement variant="mobile">
                  {activeStep + 1}/{STEPS.length}
                </StepperHeaderElement>
              </StepperHeader>

              <Row
                aria-label={intl.formatMessage(messages.prenotazioni_steps, {
                  tot_steps: STEPS.length,
                  actual_step: String(activeStep + 1),
                  step_label: STEPS[activeStep].label,
                })}
              >
                {/* STEP LUOGO */}
                {STEPS[activeStep].id === 'stepLuogo' && (
                  <PrenotazioneLuogo
                    prenotazioneObj={prenotazioneObj}
                    setPrenotazioneObj={setPrenotazioneObj}
                    activeStep={activeStep}
                    setActiveStep={setActiveStep}
                    scrollToTop={scrollToTop}
                    params={params}
                  />
                )}

                {/* STEP DATA E ORA */}
                {STEPS[activeStep].id === 'stepData' && (
                  <PrenotazioneDataEOra
                    prenotazioneObj={prenotazioneObj}
                    setPrenotazioneObj={setPrenotazioneObj}
                    activeStep={activeStep}
                    setActiveStep={setActiveStep}
                    scrollToTop={scrollToTop}
                    params={params}
                  />
                )}

                {/* STEP DETTAGLI */}
                {STEPS[activeStep].id === 'stepDettagli' && (
                  <PrenotazioneDettagli
                    prenotazioneObj={prenotazioneObj}
                    setPrenotazioneObj={setPrenotazioneObj}
                    activeStep={activeStep}
                    setActiveStep={setActiveStep}
                    scrollToTop={scrollToTop}
                    params={params}
                  />
                )}

                {/* STEP RICHIEDENTE */}
                {STEPS[activeStep].id === 'stepRichiedente' && (
                  <PrenotazioneRichiedente
                    prenotazioneObj={prenotazioneObj}
                    setPrenotazioneObj={setPrenotazioneObj}
                    activeStep={activeStep}
                    setActiveStep={setActiveStep}
                    scrollToTop={scrollToTop}
                    params={params}
                  />
                )}

                {/* STEP RIEPILOGO */}
                {STEPS[activeStep].id === 'stepRiepilogo' && (
                  <PrenotazioneRiepilogo
                    prenotazioneObj={prenotazioneObj}
                    setActiveStep={setActiveStep}
                    setBackToSlots={setBackToSlots}
                    scrollToTop={scrollToTop}
                    params={params}
                    prenotazioneState={prenotazione}
                  />
                )}
              </Row>
            </StepperContainer>
            {/* // TODO: aggiungere toolbar */}
            {/* {isClient && (
                <Portal node={document.getElementById('toolbar')}>
                  <Toolbar
                    pathname="/prenotazione-appuntamenti-uffici"
                    inner={<div />}
                    // XXX: con hideDefault viene nascosto anche lo user,
                    // oltre ai buttons delle action content ....
                    hideDefaultViewButtons
                    // inner={
                    //   <Link
                    //     to="/contents"
                    //     aria-label={intl.formatMessage(
                    //       messages.back,
                    //     )}
                    //   >
                    //     <Icon
                    //       name={backSVG}
                    //       className="contents circled"
                    //       size="30px"
                    //       title={intl.formatMessage(messages.back)}
                    //     />
                    //   </Link>
                    // }
                  />
                </Portal>
              )}  */}
          </>
        ) : (
          <></>
        )}

        {/* Add prenotazione failed */}
        {prenotazione.error && !backToSlots && (
          <PrenotazioneFailed
            error={prenotazione.error}
            setActiveStep={setActiveStep}
            setBackToSlots={setBackToSlots}
            prenotazioneObj={prenotazioneObj}
            setPrenotazioneObj={setPrenotazioneObj}
            scrollToTop={scrollToTop}
            params={params}
          />
        )}

        {/* Add prenotazione success */}
        {prenotazione.result && (
          <PrenotazioneConferma
            result={prenotazione.result}
            booking_folder={prenotazioneObj.booking_folder}
            booking_office={prenotazioneObj.booking_office}
            bookingExist={bookingExist}
            scrollToTop={scrollToTop}
            params={params}
          />
        )}
      </Container>
    </>
  );
};

export default PrenotazioneView;
